import { render } from "./teachingBehaviorDataEchart.vue?vue&type=template&id=801ad012&scoped=true"
import script from "./teachingBehaviorDataEchart.vue?vue&type=script&lang=js"
export * from "./teachingBehaviorDataEchart.vue?vue&type=script&lang=js"

import "./teachingBehaviorDataEchart.vue?vue&type=style&index=0&id=801ad012&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801ad012"]])

export default __exports__